import React from 'react'

import {colors} from "../../utils/styles"

const greyCircle = {
  boxSizing: 'border-box',
  width: 40,
  height: 40,
  border: 'solid 1px #85898c',
  borderRadius: '50%',
  lineHeight: '40px',
  textAlign: 'center',
  color: colors.grayMiddle
}

const solidBlueCircle = {
  boxSizing: 'border-box',
  width: 40,
  height: 40,
  border: 'solid 1px #0069a6',
  background: '#0069a6',
  color: 'white',
  borderRadius: '50%',
  lineHeight: '40px',
  textAlign: 'center'
}

const blueOuterCircle = {
  boxSizing: 'border-box',
  width: 40,
  height: 40,
  border: 'solid 4px #0069a6',
  borderRadius: '50%',
  textAlign: 'center',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
}

const blueInnerCircle = {
  boxSizing: 'border-box',
  width: 28,
  height: 28,
  border: 'solid 2px #0069a6',
  borderRadius: '50%',
  lineHeight: '26px',
  textAlign: 'center',
  color: colors.blue
}

export class ProgressBar extends React.Component {

  getCircle(index, position) {
    if (index > position) {
      return <div style={greyCircle}>{index + 1}</div>
    }
    if (index < position) {
      return <div style={solidBlueCircle}>{index + 1}</div>
    }
    return <div style={blueOuterCircle}>
      <div style={blueInnerCircle}>
        {index + 1}
      </div>
    </div>
  }

  render() {
    const {steps, position} = this.props
    return (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <div style={{display: 'flex', flexDirection: ' row', marginBottom: 5, fontWeight: 600}}>
            {steps.map((each, index) => {
              const showLine = index < (steps.length - 1)
              return (
                  <React.Fragment key={index}>
                    <div>
                      {this.getCircle(index, position)}
                    </div>
                    {showLine && <div style={{
                      width: 150,
                      height: 20,
                      borderBottom: 'solid 1px #85898c',
                    }}/>}
                  </React.Fragment>
              )
            })}
          </div>
          <div style={{display: 'flex', flexDirection: 'row'}}>
            {steps.map((each, index) => {
              let fontColor = index === position
                  ? colors.blue
                  : (index < position) ? colors.grayDark : colors.grayMiddle
              return (<div key={index}
                           style={{
                             width: steps[index].size,
                             textAlign: 'center',
                             color: fontColor
                           }}>{steps[index].label}</div>)
            })}
          </div>
        </div>
    )
  }
}